module.exports = __webpack_public_path__ + "assets/afe4384c8de67452dcda1c9d199ecb77.png";